import React from 'react';
import { Tag, Tooltip } from 'antd';
import { useRuntimeCorrelationNavigation } from '../../../hooks/useRuntimeCorrelationNavigation';

const RuntimeCorrelationChip = ({
  correlationId,
  tooltip = 'Abrir busca por correlation_id',
  onClick,
}) => {
  const { goToCorrelation } = useRuntimeCorrelationNavigation();
  const normalized = String(correlationId || '').trim();

  if (!normalized) {
    return <Tag>-</Tag>;
  }

  const handleClick = () => {
    if (typeof onClick === 'function') {
      onClick(normalized);
      return;
    }
    goToCorrelation(normalized);
  };

  return (
    <Tooltip title={tooltip}>
      <Tag
        color="processing"
        style={{ cursor: 'pointer', marginInlineEnd: 0 }}
        onClick={handleClick}
      >
        {normalized}
      </Tag>
    </Tooltip>
  );
};

export default RuntimeCorrelationChip;